import { render, staticRenderFns } from "./StepDataIngestionmulti.vue?vue&type=template&id=13dab272&scoped=true&"
import script from "./StepDataIngestionmulti.vue?vue&type=script&lang=js&"
export * from "./StepDataIngestionmulti.vue?vue&type=script&lang=js&"
import style0 from "./StepDataIngestionmulti.vue?vue&type=style&index=0&id=13dab272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dab272",
  null
  
)

export default component.exports